import React from 'react'
import maintenance from '../../assets/images/maintenance.svg'
import Button from '../customComponents/Button'
import { useNavigate } from 'react-router-dom'

const Maintenance = () => {
    const navigate = useNavigate()

  return (
    <div className='h-screen w-screen flex justify-center items-center flex-col gap-8'>
        <img src={maintenance} className='w-1/2 max-w-xs' alt="maintenance"/>
        <div className='flex flex-col items-center'>
            <h1 className='text-xl font-bold'>We zijn even in onderhoud...</h1>
            <p className='text-sm text-neutral-500'>Probeer binnen enkele ogenblikken eens opnieuw</p>
        </div>
        <Button onClick={()=>{navigate('/')}} value='Probeer opnieuw'/>
    </div>
  )
}

export default Maintenance